<template>
    <div class="poster-next">
        <div class="label"  @click="isShowRegister=true">
            <div class="lable-left">您企业所在的城市</div>
            <div class="lable-right">
                <span v-if="!areaName" class="placeholder">请选择</span>
                <span v-else>{{areaName}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span>
                </div>
        </div>      
        <div class="gray-line"></div>
        <div class="category-title">
            <div class="category-title-left">
                <p class="category-title-text">所属产业领域</p>
                <p>准确选择领域，不错失合适的政策</p>
            </div>
            <p v-if="areaTypeText.length>0" class="category-title-right">已选{{selectProductArr.length}}项</p>
        </div>
        <div class="category-box">
                <div class="category-box-left">
                    <div :class="['category-list',currentIdx===idx ? 'area-title' : '']" v-for="(item,idx) in areaInfoData" :key="item.industryName" @click="getDataItemHandle(idx,item)">
                        <p>{{item.industryName}}<span style="opacity:0">{{item.checkChildValue && item.checkChildValue.length}}</span></p>
                        <span v-if="!item.ck" class="check-box"></span>
                        <img v-else-if="item.ck && (item.checkChildValue && item.checkChildValue.length < areaInfoData[idx].children.length)" src="@/assets/img/companyInfo/half-checked.png" alt="">
                        <img v-else-if="item.ck && ( item.checkChildValue && item.checkChildValue.length === areaInfoData[idx].children.length)" src="@/assets/img/companyInfo/checked.png" alt="">
                    </div>
                </div>
                <div class="category-box-right">
                    <van-checkbox shape="square" name="0" v-model="allCheck[currentIdx]" @click="allCheckHandle">全选</van-checkbox>
                    <van-checkbox-group v-model="areaTypeText" :ref="`checkboxchild${currentIdx}`">
                    <van-checkbox shape="square" :name="item.industryId" v-for="(item,index) in areaInfoData[currentIdx].children" :key="item.industryName"  @click="getDataChildClick(item,index)">{{item.industryName}}<span style="opacity:0">{{currentIdx}}</span></van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <div class="space-height"></div>
            <div class="btn-box">
                <button class="category-btn-con" @click="categoryConfirm">开始评测</button>
            </div>
        <van-popup v-model="isShowRegister" round position="bottom" class="popup-box" :style="{ height: '75%' }" :closeable="true" close-icon-position="top-left" :afe-area-inset-bottom="true">  
            <div class="popup-head">
                <div class="popup-title">选择地区</div>
                <div class="popup-confirm" @click="confirmHandle">确定</div>
            </div>
            <div class="tabs-box" :style="provinceVal.name ? 'width:40%' : 'width:20%'">
                <van-tabs v-model="activeArea" title-inactive-color="#999999" title-active-color="#333333" color="#398DFF" line-width="20" line-height="2" :border="false">
            <van-tab :title="provinceVal.name ? provinceVal.name : '请选择'" name="a">
                <div class="tab-box">
                <div :class="['select-li',provinceVal.id === item.id ? 'active-li' : '']" v-for="item in province" :key="item.id" @click="slectAreaHandle(item)">{{item.name}}<span v-if="provinceVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                </div>
            </van-tab>
            <van-tab v-if="provinceVal.name" :title="cityVal.name ? cityVal.name : '请选择'" name="b">
                <div class="tab-box">
                <div :class="['select-li',cityVal.id === item.id ? 'active-li' : '']" v-for="item in cityArr" :key="item.id" @click="slectCityHandle(item)">{{item.name}}<span v-if="cityVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                </div>
            </van-tab>
            </van-tabs>
            </div>
            <div class="space-block"></div>
        </van-popup>
        <van-popup round v-model="isLoading" close-on-popstate="true">
            <div class="loading-content">
                <img src="@/assets/img/poster-img/search-loading.png" alt="">
                <p>正在努力搜索政策结果…</p>
            </div>
            
        </van-popup>
    </div>
</template>
<script>
import {registeRarea,companyDictCate} from "@/api/api_company.js"
import {policyvEaluating } from "@/api/api_poster.js"
export default {
    data(){
        return {
            provinceVal:{},
            cityVal:{},
            isShowRegister:false,
            areaName:'',
            activeArea:0,
            province:[],
            cityArr:[],
            areaInfoData:[{
                children:[],
                checkChildValue:[]
            }],
            areaTypeTitle:[],
            areaTypeText:[],
            currentIdx:0,
            allCheck:[false],
            selectCate:[],
            selectProductArr:[],
            isLoading:false,
        }
    },
    mounted(){
        this.getRegisterArea('province',0)
        this.getDictCate()
    },
    methods:{
        getRegisterArea(type,regionId){
            let params={
                regionId:regionId,
                regionVersion:'1'
            }
            registeRarea(params).then(res=>{
                if(res.ok===true){
                    if(type==='province'){
                        this.province=res.data
                    }else if(type==='city'){
                        this.activeArea='b'
                        this.cityArr=res.data
                    }
                    
                }
            })
        },
        confirmHandle(){
            if(this.cityArr.length>0 && this.cityVal.name==='请选择'){
                this.$toast('请选择城市')
                return false
            }
            if(this.cityVal.name==='请选择'){
                this.areaName=this.provinceVal.name
            }else{
                this.areaName=this.provinceVal.name+this.cityVal.name
            }
            this.isShowRegister=false
        },
        slectAreaHandle(val){
            this.provinceVal=val
            this.cityVal.name="请选择"
            this.cityVal.id=''
            this.getRegisterArea('city',val.id)
        },
        slectCityHandle(val){
            this.cityVal=val
            
        },
        allCheckHandle(){
                this.areaInfoData.forEach((val,index)=>{
                    if(this.currentIdx===index){
                        if(this.allCheck[index]){
                            this.$refs[`checkboxchild${this.currentIdx}`].toggleAll(true);
                        val.children.forEach(vv=>{
                            vv.ck=!vv.ck
                        })
                        val.ck=true
                        this.$set(this.areaInfoData[index],'checkChildValue',this.areaTypeText)
                    
                    }else  if(!this.allCheck[index]){
                        this.$refs[`checkboxchild${this.currentIdx}`].toggleAll(false);
                        this.$set(this.areaInfoData[index],'checkChildValue',this.areaTypeText)
                        val.ck=false
                        val.children.forEach(vv=>{
                            vv.ck=false
                        })
                    }
                }
            })
            let arr=[]
            this.areaInfoData.forEach(ele=>{
                if(ele.checkChildValue.length>0){
                    arr.push(ele.checkChildValue)
                }
                
            })
        let asd= [].concat(...arr)
        this.areaTypeText=asd
        let arrayConArr=[]
        this.areaInfoData.forEach((element)=>{
            if(element.ck){
                arrayConArr.push(element.ck)
            }
        })
        this.selectProductArr=arrayConArr
        },
        getDataChildClick(item){
        if(item.ck){
            this.areaInfoData.forEach((val,index)=>{
            if(val.ck){
                val.children.forEach(vv=>{
                    if(vv.industryId===item.industryId){
                    val.checkChildValue.forEach((el,idx)=>{
                        if(el===item.industryId){
                            val.checkChildValue.splice(idx,1)
                            this.$set( this.areaInfoData[index],'checkChildValue',val.checkChildValue)
                            vv.ck=false
                            if(val.checkChildValue.length===0){
                                val.ck=false
                                this.allCheck[index]=false
                            }
                            this.areaTypeText.forEach((ele,inx)=>{
                                if(el===ele){
                                    this.areaTypeText.splice(inx,1)
                                }
                            })
                        }
                    })
                    }
                })
            }
        })
        }else{
                this.areaInfoData.forEach((val,index)=>{
                    if(this.currentIdx===index){
                        val.ck=true
                            val.children.forEach(vv=>{
                                if(vv.industryId===item.industryId && !vv.ck){
                                    val.checkChildValue.push(item.industryId)
                                    this.$set( this.areaInfoData[index],'checkChildValue',val.checkChildValue)
                                    vv.ck=!vv.ck
                                }
                            })
                        if(val.checkChildValue.length===val.children.length){
                            this.allCheck[index]=true
                        }
                        }
                })
        }
        let arrayConArr=[]
            this.areaInfoData.forEach((element)=>{
                if(element.ck){
                    arrayConArr.push(element.ck)
                }
            })
            this.selectProductArr=arrayConArr
        },
        categoryConfirm(){
            if(!this.areaName){
                this.$toast('请选择企业所在城市')
                return false;
            }
            if(this.areaTypeText.length===0){
                this.$toast('请至少选择一项领域')
                return false;
            }
            let arrayCon=[]
            this.areaInfoData.forEach(element=>{
                if(element.ck){
                    arrayCon.push(element.industryId)
                }
            })
            this.isLoading=true
            // let {maxCateFirst}=this.detailInfo
            // if(arrayCon.length>maxCateFirst){
            //     this.$toast(`最多可以选择${maxCateFirst}类领域`)
            //     return false;
            // }
        let params={
            cityId:this.cityVal.id,
            provinceId:this.provinceVal.id,
            industryTypeIdList:arrayCon,
            loading: false,	
        }
            policyvEaluating(params).then(res=>{
                if(res.ok===true){
                    this.isLoading=false
                    this.$router.push({
                        path:'/specialposterlast',
                        query:{info:JSON.stringify(res.data)}
                    })
                }
            })
        },
        getDataItemHandle(idx){
            let flag=false
            this.currentIdx=idx
            this.areaInfoData.forEach((val,index)=>{
                if(idx===index){
                    flag=true
                    
                }
            })
            if(flag){
                if(this.allCheck[idx]){
                        this.allCheck[idx]=true
                    }
            }else{
                if(this.allCheck[idx]){
                        this.allCheck[idx]=false
                    }
            }
            
        },
        getDictCate(){
            companyDictCate().then(res=>{
                if(res.ok===true){
                    this.areaInfoData=res.data
                    this.areaInfoData.forEach((val,index)=>{
                        this.$set( this.areaInfoData[index],'checkChildValue',[])
                        val.ck=false
                        val.children.forEach(vv=>{
                            vv.ck=false
                        })
                    })
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .van-checkbox__label{
    width:120px;
}
.poster-next{
    /deep/ .van-popup--center.van-popup--round{
        width: 300px;
    height: 360px;
    }
    .loading-content{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img{
            width:185px;
            height:158px;
            display: block;
            margin-top:81px;
        }
        p{
            font-size:18px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:25px;
            margin-top:33px;
        }
    }
}

.gray-line{
    width: 100%;
    height: 10px;
    background: #F5F5F5;
}
.category-title{
    padding: 15px 16px;
    display: flex;
    justify-content: space-between;
    .category-title-left{
        .category-title-text{
            font-size:16px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
            margin-bottom: 6px;
        }
        p{
            font-size:13px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(204,204,204,1);
            line-height:14px;
        }
    }
    .category-title-right{
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(204,204,204,1);
        line-height:14px;
    }
}
    .label{
            width:375px;
            height:44px;
            background:rgba(255,255,255,1);
            display: flex;
            justify-content: space-between;
            font-size:16px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:@darkBlack;
            line-height:44px;
            padding: 0 15px;
            align-items: center;
            .lable-left {
                .required-star{
                    color: #FA5151;
                    margin: 0;
                    padding: 0;
                    display: inline-block;
                    font-size: inherit;
                }
            }
            .lable-right{
                display: flex;
                align-items: center;
                .category-text{
                    display: inline-block;
                    max-width: 232px;
                }
                .placeholder{
                    color: @lightBlack;
                }
                .right-icon{
                font-size: 15px;
                color: @lightBlack;
                margin: 0 0 0 20px;
                display: inline-block;
            }
            }
        }.popup-head{
    display: flex;
    justify-content: flex-end;
    margin:15px 15px 0 0;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:@baseBlack;
line-height:14px;
align-items: center;
.popup-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
}
.popup-confirm{
    margin-left: 103px;
}
}
.popup-box{
    overflow: hidden;
}
.tabs-box{
    width:30%;
    margin:35px 0 0 20px;
    /deep/ .van-tabs__content{
        width: 375px;
    }
    .tab-box{
        padding: 40px 0 0 20px;
        max-height: 400px;
        overflow-x: scroll;
        .select-li{
        font-size:18px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-bottom: 30px;
        .active-icon{
            font-size: 12px;
            color: #398DFF;
        }
        }
.active-li{
    color: #398DFF;
}
    }
    /deep/ .van-tab{
        font-size: 16px;
    }
}
.space-block{
    height: 30px;
}
.tab-label{
    background:rgba(248,248,248,1);
    border-radius:3px;
    width:105px;
height:34px;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:34px;
display: inline-block;
margin-right: 10px;
margin-bottom: 10px;
text-align: center;
}
.tab-label:nth-child(3n){
    margin-right: 0px;
}
.category-box{
    display: flex;
    border-top:1px solid #EEEEEE;
}
    .category-box-left{
        width:50%;
        border-right: 1px solid #ddd;
        height: 500px;
        overflow: scroll;
        /deep/ .van-checkbox__icon{
            order: 10;
        }
        /deep/ .van-checkbox{
                justify-content: space-between;
                padding: 13px 10px 13px 20px;
        }
        .category-list{
            display: flex;
            justify-content: space-between;
            padding: 13px 20px 16px;
            align-items: flex-start;
            p{
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:18px;
            width:110px;
            }
            img{
                width:16px;
                height:16px;
                background:rgba(57,141,255,1);
                border-radius:2px;
            }
            .check-box{
                width:16px;
                height:16px;
                background:rgba(255,255,255,1);
                border-radius:2px;
                border:1px solid rgba(221,221,221,1);
            }
        }
        .area-title{
            background: #EBF3FF;
            // padding-right: 10px;
            p{
                color:rgba(57,141,255,1);
            }
        }
        .check-box-square{
            width:16px;
            height:16px;
            background:rgba(255,255,255,1);
            border-radius:2px;
            border:1px solid rgba(221,221,221,1);
            display: inline-block;
        }
        .img-icon{
            width:16px;
            height:16px;
        }
    }
    .category-box-right{
        width:50%;
        padding-left: 13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:14px;
        height: 500px;
        overflow: scroll;
        /deep/ .van-checkbox__icon{
            order: 10;
        }
        /deep/ .van-checkbox{
                justify-content: space-between;
                padding: 13px 20px 13px 0;
                align-items: flex-start;
        }
        /deep/ .van-checkbox__icon .van-icon{
            width:16px;
            height: 16px;
            border-radius:2px;
            border: 1px solid #dddddd;
        }
        /deep/ .van-checkbox__icon--checked .van-icon{
            width:16px;
            height: 16px;
            background:url('../../assets/img/companyInfo/checked.png');
            background-size: cover;
            border-color:transparent;
            border:0;
            display: inline-block;
        }
        /deep/ .van-icon-success::before{
            content: '';
        }
    }
    .space-height{
    height:80px;
}
.btn-box{
    position:fixed;
    bottom: 0;
    width:375px;
    height:72px;
    background:rgba(255,255,255,1);
    display: flex;
    justify-content: center;
    align-items: center;
}
.category-btn-con{
    width:335px;
    height:40px;
    background:rgba(57,141,255,1);
    border-radius:3px;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
    text-align: center;
    margin: 20px auto;
    border: 0;
    outline: none;
    display: block;
}
</style>